import { NUMBER } from "../../../constants/app-constants";
import { DOC_FAILED_STATUSES } from "../post-inspection-diy/constant";

export const getDocumentStatuses = ({totalDocumentCount, pendingDocumentCount, failedDocCount}) => {
    const documentUploadCount = totalDocumentCount - pendingDocumentCount;
    const progressValue = `${(documentUploadCount / totalDocumentCount) * NUMBER.HUNDRED}%`;
    const isAnyDocPending = pendingDocumentCount || failedDocCount;
    return {
        documentUploadCount,
        progressValue,
        isAnyDocPending
    };
};

export const getGaEventActionName = ({
    isAnyDocPending,
    failedDocCount,
    documentUploadCount
}) => {
    if (isAnyDocPending) {
        if (failedDocCount) return "Doc Upload doc verification failed view";
        if (documentUploadCount) return `Doc Upload ${documentUploadCount} document uploaded`;
        return "Doc Upload page view";
    }
    return "Doc Upload doc being verified view";
};

export const getDocumentProgressStyle = (documentUploadCount, totalDocumentCount) => {
    if (documentUploadCount === totalDocumentCount) return "styles.verified";
    if (documentUploadCount > NUMBER.ZERO) return "styles.progress";
    return "";
};

export const filterRequiredDocumentList = (documentdata = {}, key) => {
    const requiredDocumentList = documentdata[key] || [];
    return {[key]: requiredDocumentList};
};

export const checkIfMisMatch = (doc = {}) => DOC_FAILED_STATUSES.includes(doc.reason);

